import { MabyeWrappedError } from "./MaybeWrappedError";

// Required for docstring.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { NonUserError } from "./NonUserError";
// Required for docstring.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { ErrorReporterService } from "src/services/error-reporter.service";

/**
 * Represents an error that has already been completely addressed previously
 * upstream, but where it's important for code-flow to keep rethrowing.
 *
 * Please note that this include outputting any debugging information that could be useful.
 *
 * If you just want to supress the end-user displayed error toast, please use {@link NonUserError}
 *
 * If this is passed to {@link ErrorReporterService.prototype.handle | ErrorReporterService#handle}
 * it will result in a noop
 */
export class SilentError extends MabyeWrappedError {}
